import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../interceptors/authentication.service';
import { UserRole } from '../models/user-role';

@Directive({
  selector: '[appIsSuperAdmin]'
})
export class IsSuperAdminDirective {

  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthenticationService) {

    if (this.authService.isSuperAdmin())
      this.viewContainer.createEmbeddedView(this.templateRef);
    else
      this.viewContainer.clear();
  }
}
